<template>
	<Modal :title="title" @close="$store.commit('closeModal')">
		<p>
			Do you really want to delete this item?. It cannot be restored
			afterwards.
		</p>

		<template slot="footer">
			<Button @click="$store.commit('closeModal')" type="tertiary"
				>Cancel</Button
			>
			<Button
				ref="primaryAction"
				@click="$store.commit('confirmModal', true)"
				type="danger"
				icon="trash-alt"
				autofocus
				tabindex="0"
			>
				Delete
			</Button>
		</template>
	</Modal>
</template>
<script>
import Modal from '~/components/ui/layout/Modal'
import Button from '~/components/ui/common/Button'

export default {
	components: {
		Modal,
		Button
	},
	props: {
		title: {
			type: String,
			default: 'Delete Item'
		}
	},
	mounted() {
		this.$refs.primaryAction.focus()
	}
}
</script>
